import { ContextBar, ContextButton, DetailList } from '@tecuity/granite-ui'
import React, { useEffect, useMemo } from 'react'
// import { useSelector, shallowEqual } from 'react-redux';
import { getCorrectionInfo, mergeCorrection } from './WorkviewActions'
import CheckmarkIcon from '@tecuity/sos-icons/react/check'
import { useState } from 'react'
import { Spinner } from '../Loaders/Loaders'

const CorrectionResolver = ({ selectedRow, changeView, closeCorrectionResolver }) => {
  // const { appUserRights } = useSelector(state => state.auth, shallowEqual);
  const [correctionInfo, setCorrectionInfo] = useState(null)
  const [showLoadingSpinner, setShowLoadingSpinner] = useState(false)

  useEffect(() => {
    getCorrectionInfo(selectedRow.Filing.Num, setCorrectionInfo)
  }, [])

  const correctionDetail = useMemo(() => {
    if (!correctionInfo) {
      return []
    }

    return [
      { label: 'Correction Number', value: correctionInfo.CorrespondenceNum },
      { label: 'Name', value: correctionInfo.Name },
      { label: 'DLN', value: correctionInfo.DLN },
      { label: 'Source Type', value: correctionInfo.SourceType },
      { label: 'Created Date', value: correctionInfo.CreatedDate },
    ]
  }, [correctionInfo])

  const approveItem = () => {
    setShowLoadingSpinner(true)
    mergeCorrection(correctionInfo.CorrespondenceNum, selectedRow.DLN, () => {
      closeCorrectionResolver(false)
      changeView(null, 0)
      setShowLoadingSpinner(false)
    })
  }

  return (
    <div className="wvm-modal">
      {!correctionInfo || showLoadingSpinner ? (
        <div className="loader-wrapper">
          <Spinner className="page-loader" themeColor="dark-neutral" />
        </div>
      ) : (
        <React.Fragment>
          <div className="info-row">
            <DetailList
              details={correctionDetail}
              topBorder
              bottomBorder
              customCss={{ width: '100%' }}
            />
          </div>
          <ContextBar
            elevation="standard"
            customCss={{ marginBottom: '15px' }}
            className="granite-context-bar"
          >
            <div className="context-button-wrapper">
              <ContextButton
                disabled={showLoadingSpinner}
                onClick={approveItem}
                rightIcon={
                  <div className="checkmark-wrapper right">
                    <CheckmarkIcon />
                  </div>
                }
                variant="primary"
              >
                Process
              </ContextButton>
            </div>
          </ContextBar>
        </React.Fragment>
      )}
    </div>
  )
}

export default CorrectionResolver
